import { selectBuildingPurchaseWorkerRequirement } from "../../../../selectors/selectExistingBuildingInfo";
export var checkBuildingPurchaseHasEnoughWorker = function (path) { return function (action, state$) {
    var state = state$.value;
    var _a = selectBuildingPurchaseWorkerRequirement(state, action.building, 0), freeWorkers = _a.freeWorkers, workerRequirement = _a.workerRequirement;
    var leftWorker = freeWorkers + workerRequirement;
    if (leftWorker < 0) {
        return path;
    }
    return undefined;
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/buildings/checks/checkBuildingPurchaseHasEnoughWorker.ts
// module id = 2063
// module chunks = 3